if ('production' !== process.env.NODE_ENV) {
	module.exports = require('./configureStore.dev.js');
} else {
	module.exports = require('./configureStore.dist.js');
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js